import { render, staticRenderFns } from "./SkeletonDetail.vue?vue&type=template&id=71c4077b"
import script from "./SkeletonDetail.vue?vue&type=script&lang=js"
export * from "./SkeletonDetail.vue?vue&type=script&lang=js"
import style0 from "./SkeletonDetail.vue?vue&type=style&index=0&id=71c4077b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports